export var DashboardSettingsRoutes;
(function (DashboardSettingsRoutes) {
    DashboardSettingsRoutes["settings"] = "dasboard_settings";
    DashboardSettingsRoutes["navigation"] = "";
    DashboardSettingsRoutes["devices"] = "/dasboard_settings/devices";
    DashboardSettingsRoutes["device"] = "/dasboard_settings/devices/device";
})(DashboardSettingsRoutes || (DashboardSettingsRoutes = {}));
